/**
 * Presentation-only state shared between the input layer, panel, and renderer.
 * None of this exists in the sim: it can change freely without touching
 * determinism.
 */
import type { SlateKey } from '../data/balance.js';
import type { GridPoint } from '../core/types.js';

export interface ActionPreview {
  readonly result: GridPoint | null;
  readonly consume: readonly GridPoint[];
  readonly dim: readonly GridPoint[];
}

export interface FloatText {
  readonly x: number;
  readonly y: number;
  readonly txt: string;
  readonly color: string;
  t: number;
}

export interface ViewState {
  hoverCell: GridPoint | null;
  selectedCell: GridPoint | null;
  /** Ghost stone awaiting the confirming second tap (touch flow). */
  pendingPlace: GridPoint | null;
  /** Slate forge awaiting its socket rock (tap a highlighted rock to place). */
  pendingSlate: { readonly i: number; readonly key: SlateKey } | null;
  /** First slate selected for a greater combine (tap its partner next). */
  pendingSlateUp: GridPoint | null;
  actionPreview: ActionPreview | null;
  mouseCanvas: { mx: number; my: number } | null;
  floats: FloatText[];
  animT: number;
  replayMode: boolean;
}

export function createViewState(): ViewState {
  return {
    hoverCell: null,
    selectedCell: null,
    pendingPlace: null,
    pendingSlate: null,
    pendingSlateUp: null,
    actionPreview: null,
    mouseCanvas: null,
    floats: [],
    animT: 0,
    replayMode: false,
  };
}
